import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Switch, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  goTogether: boolean;
  onGoTogetherChange: (value: boolean) => void;
  goTogetherEnabled: boolean;
  legacy?: boolean;
}

export const SubmissionTypeCard: React.FC<Props> = ({
  goTogether,
  onGoTogetherChange,
  goTogetherEnabled,
  legacy,
}) => {
  const { tokens } = useTheme<LensTheme>();
  const color = tokens.semantic.color;
  return (
    <Box
      data-testid="submission-type-card"
      sx={{
        border: `1px solid ${color.ui.divider.default.value}`,
        borderRadius: tokens.semantic.radius.md.value,
        padding: tokens.semantic.spacing.desktop.gap[2].value,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography
        sx={{
          fontWeight: tokens.semantic.fontWeight.emphasis.value,
          fontSize: '16px',
        }}
      >
        Submission type
      </Typography>
      <Typography sx={{ fontSize: '12px', color: color.type.muted.value }}>
        {legacy
          ? 'Enable GoTogether to hold reports until a second report about the same directory-linked offender is submitted.'
          : 'Enable GoTogether to hold reports until a second report about the same directory-linked offender is submitted, or GoAhead to send named reports directly for review.'}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Switch
          data-testid="submission-go-together"
          checked={goTogether}
          disabled={!goTogetherEnabled}
          onChange={(e) => onGoTogetherChange(e.target.checked)}
          slotProps={{
            input: {
              'aria-label': 'GoTogether',
              sx: { width: '100% !important', height: '100% !important' },
            },
          }}
        />
        <Typography sx={{ fontSize: '14px' }}>GoTogether</Typography>
      </Box>
      {!legacy && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Switch
            data-testid="submission-go-ahead"
            checked
            disabled
            slotProps={{
              input: {
                'aria-label': 'GoAhead',
                sx: { width: '100% !important', height: '100% !important' },
              },
            }}
          />
          <Typography sx={{ fontSize: '14px' }}>GoAhead</Typography>
        </Box>
      )}
    </Box>
  );
};
